module.exports = __webpack_public_path__ + "assets/img/networks-home-default-banner.101f8026.jpeg";